<template>
  <div v-if="!customMessage" class="container">
    <div style="font-size: 13px; margin-bottom: 11px">{{ $t('messages.messages') }}</div>
    <div class="message-wrapper">
      <b-col cols="12">
        <input type="text" :value="messageValue" :disabled="!customMessage" :placeholder="$t('messages.messages')" />
      </b-col>
      <b-col cols="12" class="message-list">
        <ul>
          <li
            class="p-whiteSpace ellipses"
            data-bs-toggle="tooltip"
            :title="messageTooltip(message.title, message.message)"
            v-for="message in messages"
            :key="message.id"
            @click="selctedMessage(message)"
          >
            {{ message.title }}
            {{ message.message }}
          </li>
        </ul>
      </b-col>
      <b-col class="custom-message" @click="customMessage = true" cols="12">
        <div class="plusClass">
          <img src="@/assets/images/blue-pluss.svg" alt="plus" />
        </div>
        <button>{{ $t('messages.customText') }}</button>
      </b-col>
      <b-col cols="12" class="_buttons">
        <div @click="$emit('closeModal', (discardBtnClicked = false))">
          <Button :text="$t('messages.discard')" btnClass="discard" />
        </div>
        <div @click="$emit('selectCustomMessage', messageId)
        $emit('selectedMessageText', selectedMessageText)
        ">
          <Button :loading="selectLoading" :text="$t('messages.choose')" btnClass="aprove" />
        </div>
      </b-col>
    </div>
  </div>
  <div v-else>
    <h5>{{ $t('messages.messages') }}</h5>
    <div class="message-wrapper">
      <b-col cols="12">
        <input type="text" :placeholder="$t('messages.messages')" v-model="customTitle" />
      </b-col>
      <b-col cols="12">
        <div class="text-message">
          <textarea v-model="customTextMessage" :placeholder="$t('messages.messageText')" cols="30" rows="10"></textarea>
        </div>
      </b-col>
      <b-col cols="12" class="_buttons">
        <Button @click.native="closeSecondModal" :text="$t('messages.discard')" btnClass="discard" />
        <div @click="$emit('typedCustomMessage', { customTitle, customTextMessage })">
          <Button :text="$t('messages.approve')" :loading="aproveLoading" btnClass="aprove" />
        </div>
      </b-col>
    </div>
  </div>
</template>

<script>
import Button from '../common/Button.vue'

export default {
  components: {
    Button,
  },
  props: {
    messages: {
      type: Array,
    },
    selectLoading: {
      type: Boolean,
      default: false,
    },
    aproveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      messageValue: null,
      customMessage: false,
      messageId: null,
      discardBtnClicked: null,
      customTitle: '',
      customTextMessage: '',
      selectedMessageText: ''
    }
  },
  methods: {
    messageTooltip(title, message) {
      if (title) {
        return title + '\n' + message
      } else {
        return message
      }
    },
    selctedMessage(message) {
      if (message.title) {
        this.messageValue = message.title
      } else {
        this.messageValue = message.message.slice(0, 50) + '...'
      }
      this.messageId = message.id
      this.selectedMessageText = message.message
    },
    closeSecondModal() {
      this.customMessage = false
    },
  },
}
</script>

<style scoped>
.ellipses {
  width: 38em;
  overflow: hidden;
  text-overflow: ellipsis;
}
.message-wrapper input,
textarea {
  width: 100%;
  border: 1px solid #eaeaea;
  border-radius: 5px;
  padding: 6px;
  outline: none;
}
.message-wrapper input::placeholder,
textarea::placeholder {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
}
.message-wrapper .message-list {
  border: 1px solid #eaeaea;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  margin-top: 3px;
  max-height: 175px;
  overflow: auto;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #556ee6;
}
.message-wrapper .message-list ul,
li {
  margin: 0;
  padding: 0;
  background-color: white;
}
.message-wrapper .message-list li {
  cursor: pointer;
  color: #495057;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  padding-right: 4px;
  height: 35px;
  line-height: 35px;
}
.custom-message {
  cursor: pointer;
  display: flex;
  align-items: center;
  border: 1px solid #eaeaea;
  border-radius: 0 0 5px 5px;
}
.plusClass {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.custom-message button {
  background-color: white;
  color: #556ee6;
  width: 100%;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0px;
  text-align: right;
}
.text-message {
  margin-top: 10px;
  border: 1px solid #eaeaea;
  border-radius: 5px;
}
.text-message textarea {
  width: 100%;
  border: none;
  outline: none;
}
._buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  text-align: left;
}
.aprove {
  background-color: #556ee6 !important;
  border-radius: 5px !important;
  width: 119px !important;
  margin-right: 4px !important;
}
.discard {
  border-radius: 4px !important;
  background-color: rgba(51, 51, 51, 0.6) !important;
}
</style>
